export default __webpack_public_path__ + "static/media/avatar.89b074ce.png";